export default {"src":"/_next/static/media/info.adbb02ce.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};